import { flexRender } from "@tanstack/react-table";
import { ReactSVG } from "react-svg";
import arrowsUpDownIcon from "../../icon/ArrowsDownUp.svg";
import "../../style/table.scss";

const SORT_BUTTON_SIZE = "12px";

const SORT_BUTTON_SVGS = {
    asc: arrowsUpDownIcon,
    desc: arrowsUpDownIcon,
};

/**
 * Header for table.
 * @param {object} props
 * @param {import("@tanstack/react-table").HeaderGroup[]} props.headerGroups Header groups for the table.
 */
function TableHeader({ headerGroups }) {
    return (
        <thead>
            {headerGroups.map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th
                            key={header.id}
                            colSpan={header.colSpan}
                            style={{
                                width: header.column.columnDef.width,
                                cursor: header.column.getCanSort() ? "pointer" : "default",
                                userSelect: header.column.getCanSort() ? "none" : "auto",
                            }}
                            onClick={header.column.getToggleSortingHandler()}
                        >
                            {header.isPlaceholder ? null : (
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                    {header.column.getCanSort() && (
                                        <ReactSVG
                                            src={SORT_BUTTON_SVGS[header.column.getIsSorted()] ?? SORT_BUTTON_SVGS.desc}
                                            beforeInjection={(svg) => {
                                                svg.setAttribute("width", SORT_BUTTON_SIZE);
                                                svg.setAttribute("height", SORT_BUTTON_SIZE);
                                            }}
                                        />
                                    )}
                                </div>
                            )}
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
    );
}

export default TableHeader;
